export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}classifier/budget/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        getStartYear: {
            method: 'GET',
            url: `${SEED_CORE.ENV.API_URL}classifier/budget/get-start-year`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/ClassifierBudget/index.js